import { useState, useEffect } from "react";
import OverviewPrice from "./Overview_price";
import { NewDynamicTab } from "../../../components/Page";
import {
  GridcoOverviewDefaultDates,
  RuvitalOverview,
} from "../../../config/DefaultDates";
import { GridcoTitle } from "../components";
import GridcoOverview from "./EntityAnalysis";
import { TabSwitcher } from "../Gridco_Das";

const TABS = ["Procurement Vs Consumption", "Entity Analysis"];

export function GridcoOverviewTab() {
  // Get initial tab from URL or default to "Restricted Demand"
  const initialTab =
    new URLSearchParams(window.location.search).get("tab") || TABS[0];
  const [selectedTab, setSelectedTab] = useState(initialTab);

  useEffect(() => {
    // Update selected tab if URL changes
    const handlePopState = () => {
      const tab = new URLSearchParams(window.location.search).get("tab");
      if (tab && TABS.includes(tab)) {
        setSelectedTab(tab);
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return (
    <NewDynamicTab
      defaultDates={GridcoOverviewDefaultDates}
      middleComponent={<GridcoTitle />}
      headerPrefixComponent={<TabSwitcher />}
      header="Overview"
      tabs={{
        "By Summary": <GridcoOverview />,
        // "By Product": <OverviewPrice />,
      }}
    />
  );
}
